import React from 'react';
import StockHeader from '../../components/StockHeader/StockHeader';
import pageStyle from '../../components/StockPage/StockPage.module.css';
import style from './TargetPricePage.module.css';
import TargetPriceList from '../TargetPriceList/TargetPriceList';
import Container from '../../components/Container/Container';
import StockDetails from '../../components/StockDetails/StockDetails';
import { formatCurrency } from '../../helpers/format';
import AnalystRecommendations from '../../components/AnalystRecommendations/AnalystRecommendations';
import TargetPrice from '../TargetPrice/TargetPrice';

const TargetPricePage = (props) => {
  return (
    <div className={pageStyle.pageContainer}>
      <a href={`/stocks/${props.stock.symbol.toLowerCase()}`} className={style.blueLink}>
        <img src="/react/phosphor/caret-left-bold.svg" alt="Back" width="14" height="14" />
        <span>{props.stock.simple_name} Overview</span>
      </a>

      <StockHeader
        stock={props.stock}
        title={`${props.stock.simple_name} Target Price`}
        subtitle={`Analysts' 12-month price predictions for ${props.stock.symbol}.`}
        rightSection={<HeaderMetrics price={props.price} />} />

      <Container>
        <div className={`${pageStyle.flexGrid} ${pageStyle.boxes}`}>
          <div>
            <h3 className={style.headline}>Average Target Price</h3>
            <TargetPrice price={props.price} price_target_summary={props.price_target_summary} />
          </div>
          <div>
            <h3 className={style.headline}>Analyst Recommendations</h3>
            <AnalystRecommendations stock={props.stock} showNoDataMessage />
          </div>
        </div>

        <h3 className={style.title}>Revenue &amp; Income Forecast</h3>
        <StockDetails stock={props.stock} hideDetails />
      </Container>

      <Container>
        <h3 className={style.title}>Analysts' Target Prices</h3>
        <TargetPriceList price={props.price} price_targets={props.price_targets} />
      </Container>
    </div>
  )
}

export default TargetPricePage;

function HeaderMetrics({ price }) {
  if (!price) return null;

  return (
    <div className={style.headerMetrics}>
      <h3 className={style.headerMetricsKey}>Share Price</h3>
      <p className={style.headerMetricsValue}>${formatCurrency(price)}</p>
    </div>
  )
}